var AppConstants = require('../constants/AppConstants');
var AppDispatcher = require('../dispatcher/AppDispatcher');

var ActionTypes = AppConstants.ActionTypes;

var LoginActions = {

  submitForgotPassword: function (userId, urlDetails, notificationChannel) {
    var action = {
      type: ActionTypes.SUBMIT_FORGOT_PASSWORD,
      userId,
      urlDetails: urlDetails,
      notificationChannel,
    };
    AppDispatcher.dispatch(action);
  },

  submitChangePassword: function (loginId,currentPassword, newPassword, userType, traceId) {
    var action = {
      type: ActionTypes.SUBMIT_CHANGE_PASSWORD,
      loginId : loginId,
      currentPassword: currentPassword,
      newPassword: newPassword,
      userType: userType,
      traceId: traceId
    };
    AppDispatcher.dispatch(action);
  },

  submitResetPassword: function (password, urlDetails) {
    var action = {
      type: ActionTypes.SUBMIT_RESET_PASSWORD,
      password: password,
      urlDetails: urlDetails
    };
    AppDispatcher.dispatch(action);
  },

submitLogin: function (userId, password, userType,clientId,responseType,countryCode,localeId,realmId,accountId,
  redirectUrl, state, prompt, nonce, scope, traceId, codeChallenge, codeChallengeMethod, captchaToken) {
    var action = {
      type: ActionTypes.SUBMIT_LOGIN,
      userId: userId,
      password: password,
      userType: userType,
      clientId:clientId,
      responseType:responseType,
      countryCode:countryCode,
      localeId:localeId,
      realmId:realmId,
      accountId:accountId,
      redirectUrl:redirectUrl,
      state:state,
      prompt,
      nonce:nonce,
      scope:scope,
      traceId: traceId,
      codeChallenge:codeChallenge,
      codeChallengeMethod:codeChallengeMethod,
      captchaToken
    };
    AppDispatcher.dispatch(action);
},

submitLoginWithPasscode: function (userId, password, oneTimePasscode, userType,clientId,responseType,countryCode,localeId,realmId,accountId,
  redirectUrl,state,nonce,scope, traceId, codeChallenge, codeChallengeMethod) {
    var action = {
      type: ActionTypes.SUBMIT_LOGIN_WITH_PASSCODE,
      userId: userId,
      password: password,
      oneTimePasscode: oneTimePasscode,
      userType: userType,
      clientId:clientId,
      responseType:responseType,
      countryCode:countryCode,
      localeId:localeId,
      realmId:realmId,
      accountId:accountId,
      redirectUrl:redirectUrl,
      state:state,
      nonce:nonce,
      scope:scope,
      traceId: traceId,
      codeChallenge:codeChallenge,
      codeChallengeMethod:codeChallengeMethod
    };
    AppDispatcher.dispatch(action);
  },

submitSamlLogin: function (userId, password, userType, clientId, countryCode, localeId, realmId, traceId) {
    var action = {
      type: ActionTypes.SUBMIT_SAML_LOGIN,
      userId: userId,
      password: password,
      userType: userType,
      clientId:clientId,
      countryCode:countryCode,
      localeId:localeId,
      realmId:realmId,
      traceId: traceId
    };
    AppDispatcher.dispatch(action);
  },

  submitTOTP: function(totp, idToken, userId, countryCode, realmId, userType, traceId) {
    var action = {
        type: ActionTypes.VALIDATE_TOTP,
        userId: userId,
        countryCode: countryCode,
        realmId: realmId,
        totp: totp,
        idToken: idToken,
        userType: userType,
        traceId: traceId
    };
    AppDispatcher.dispatch(action);
  },
    submitTOTPWithSession: function(totp, idToken, userId, countryCode, realmId, userType, traceId, startSessionIdentifier, totpType, totpName) {
        var action = {
            type: ActionTypes.VALIDATE_TOTP_WITH_SESSION,
            userId: userId,
            countryCode: countryCode,
            realmId: realmId,
            totp: totp,
            idToken: idToken,
            userType: userType,
            traceId: traceId,
            startSessionIdentifier: startSessionIdentifier,
            totpType,
            totpName
        };
        AppDispatcher.dispatch(action);
    },
    submitAuthenticatorWithSession: function(authenticatorResponse, idToken, userId, countryCode, realmId, userType, traceId, startSessionIdentifier, credentialId) {
      var action = {
          type: ActionTypes.VALIDATE_AUTHENTICATOR_WITH_SESSION,
          userId: userId,
          countryCode: countryCode,
          realmId: realmId,
          authenticatorResponse: authenticatorResponse,
          idToken: idToken,
          userType: userType,
          traceId: traceId,
          startSessionIdentifier: startSessionIdentifier,
          credentialId: credentialId
      };
      AppDispatcher.dispatch(action);
    },
    submitAuthenticatorWithInitId: function(authenticatorResponse, initSessionId, loginId, traceId) {
      var action = {
          type: ActionTypes.VALIDATE_AUTHENTICATOR_WITH_INIT_ID,
          authenticatorResponse: authenticatorResponse,
          initSessionId: initSessionId,
          loginId: loginId,
          traceId: traceId
      };
      AppDispatcher.dispatch(action);
    },

  submitTOTPForgotPassword: function(totp, idToken, userId, countryCode, realmId, userType, traceId) {
    var action = {
        type: ActionTypes.VALIDATE_TOTP_FORGOT_PASSWORD,
        userId: userId,
        countryCode: countryCode,
        realmId: realmId,
        userType: userType,
        totp: totp,
        idToken: idToken,
        traceId: traceId
    };
    AppDispatcher.dispatch(action);
  },

  submitLinkHDAccount: function(userId, password, externalId, sourceSystem) { 
    const action = {
      type: ActionTypes.SUBMIT_LINK_HD_ACCOUNT,
      userId,
      password,
      externalId,
      sourceSystem
    }
    AppDispatcher.dispatch(action);
  },

  submitConsentHD: function(loginId, userType, clientId, countryCode, consent, consentCode) { 
    const action = {
      type: ActionTypes.SUBMIT_CONSENT_HD,
      loginId,
      userType,
      clientId,
      countryCode,
      consent,
      consentCode
    }
    AppDispatcher.dispatch(action);
  },

  resendTOTP: function(loginId, traceId,idToken,realmId,countryCode, userType, totpType, totpName, userRequested) {
    var action = {
        type: ActionTypes.RESEND_TOTP,
        loginId: loginId,
        traceId: traceId,
        idToken : idToken,
        realmId :realmId,
        countryCode:countryCode,
        userType: userType,
        userRequested: userRequested,
        totpType,
        totpName
    };
    AppDispatcher.dispatch(action);
   },

   getPasswordlessInfo: function(loginId, userType) {
    var action = {
        type: ActionTypes.GET_PASSWORDLESS_INFO,        
        loginId,
        userType,
    };
    AppDispatcher.dispatch(action);
  },

   getPasswordlessMethods: function(clientId, loginId, userType) {
    var action = {
        type: ActionTypes.GET_PASSWORDLESS_METHODS,        
        clientId,
        loginId,
        userType,
    };
    AppDispatcher.dispatch(action);
  },

  setIsIntranetRequestV2: function() {
    var action = {
        type: ActionTypes.SET_IS_INTRANET_REQUESTV2,        
    };
    AppDispatcher.dispatch(action);
  },

  validateOtpAuth: function(loginId, userType, otp, countryCode, fwd_client_id) {
    var action = {
        type: ActionTypes.VALIDATE_OTP_AUTH,  
        loginId,
        userType,
        otp,
        countryCode,
        fwd_client_id,
    };
    AppDispatcher.dispatch(action);
  },

  generateOtpCode: function (userId, isClientPasswordless, userType,clientId,responseType,countryCode, localeId,realmId,accountId,
    redirectUrl, state, prompt, nonce, scope, traceId, codeChallenge, codeChallengeMethod) {
      var action = {
        type: ActionTypes.GENERATE_OTP_CODE,
        userId: userId,
        isClientPasswordless: isClientPasswordless,
        userType: userType,
        clientId:clientId,
        responseType:responseType,
        countryCode:countryCode,
        localeId:localeId,
        realmId:realmId,
        accountId:accountId,
        redirectUrl:redirectUrl,
        state:state,
        prompt,
        nonce:nonce,
        scope:scope,
        traceId: traceId,
        codeChallenge:codeChallenge,
        codeChallengeMethod:codeChallengeMethod,
      };
      AppDispatcher.dispatch(action);
  },

   genAndSendOtpUsingTempSecret: function(userType, idToken, mobileNumber, countryCode, traceId, resendFlag = false) {

    var action = {
        type: ActionTypes.GENERATE_AND_SEND_OTP_USING_TEMP_SECRET,
        userType: userType,
        idToken: idToken,
        mobileNumber: mobileNumber,
        countryCode: countryCode,
        traceId,
        resendFlag
    };
    AppDispatcher.dispatch(action);
   },

  getWebPageConfigurations: function (props, localeId) {
    var action = {
      type: ActionTypes.GET_WEB_CONFIGURATIONS,
      props: props,
      localeId: localeId
    };
    AppDispatcher.dispatch(action);
  },

  triggerToast : function (toastMessage,toastType, clearToast, title){    
      var action = {
            type: ActionTypes.DISPLAY_TOAST,
            toastMessage: toastMessage,
            toastType: toastType,
            clearToast: clearToast,
            title: title,
          };
      AppDispatcher.dispatch(action);
  },

  getSupportedLocales: function(realmId, countryCode, localeId) {
    var action = {
        type: ActionTypes.GET_SUPPORTED_LOCALES,
        realmId: realmId,
        countryCode: countryCode,
        localeId: localeId
    };
    AppDispatcher.dispatch(action);
  },

  getUserLoginStrategy: function(countryCode, userType) {
    var action = {
        type: ActionTypes.GET_USER_LOGIN_STRATEGY,        
        countryCode: countryCode,
        userType: userType
    };
    AppDispatcher.dispatch(action);
  },

  getMFAOptions: function(userType, countryCode) {
    var action = {
        type: ActionTypes.GET_MFA_OPTIONS,        
        countryCode: countryCode,
        userType: userType
    };
    AppDispatcher.dispatch(action);
  },

  getAllowX590Login: function(clientId) {
    var action = {
        type: ActionTypes.GET_ALLOR_X_590_LOGIN,        
        clientId
    };
    AppDispatcher.dispatch(action);
  },

  getTwoFATempSecret: function(idToken, userType, traceId) {
    var action = {
      type: ActionTypes.GET_TWO_FA_TEMP_SECRET,
      idToken : idToken,
      userType: userType,
      traceId: traceId
    };
    AppDispatcher.dispatch(action);
  },

  validateTotpAddCode: function(idToken, userType, realmId, countryCode, traceId, code, mobileNumber) {
    var action = {
      type: ActionTypes.VALIDATE_TOTP_APP_CODE,
      idToken : idToken,
      userType: userType,
      realmId: realmId,
      countryCode: countryCode,
      code: code,
      mobileNumber: mobileNumber,
      traceId: traceId
    };
    AppDispatcher.dispatch(action);
  },

  validateAddTotpAddCode: function(idToken, userType, realmId, countryCode, traceId, code, mobileNumber, localeId, method, name) {
    const action = {
      type: ActionTypes.VALIDATE_ADD_TOTP_APP_CODE,
      idToken : idToken,
      userType: userType,
      realmId: realmId,
      countryCode: countryCode,
      code: code,
      mobileNumber: mobileNumber,
      traceId: traceId,
      localeId: localeId,
      method: method,
      name: name
    };
    AppDispatcher.dispatch(action);
  },

  getUserDetails: function(idToken, userType, traceId) {
    var action = {
      type: ActionTypes.GET_USER_DETAILS,
      idToken : idToken,
      userType: userType,
      traceId: traceId
    };
    AppDispatcher.dispatch(action);
  },
  
  createWebauthnCredentials: function(idToken, challenge, userId, email, traceId ) {
    var action = {
      type: ActionTypes.CREATE_WEBAUTHN_CREDENTIALS,
      idToken : idToken,
      challenge: challenge,
      userId: userId,
      userId:userId,
      email:email,
      traceId: traceId
    };
    AppDispatcher.dispatch(action);
  },
  captureWebauthnCredentials: function(challenge, allowedCredList) {
    var action = {
      type: ActionTypes.CAPTURE_WEBAUTHN_CREDENTIALS,
      challenge : challenge,
      allowedCredList: allowedCredList
    };
    AppDispatcher.dispatch(action);
  },
  save2FaWebAuthnCred: function(idToken, userCred, deviceName, traceId) {
    var action = {
      type: ActionTypes.SAVE_2FA_CRED,
      idToken : idToken,
      userCred: userCred,
      userId: userId,
      deviceName:deviceName,
      traceId: traceId
    };
    AppDispatcher.dispatch(action);
  },
  get2faWebAuthnCredentials: function(idToken,userId, traceId) {
    var action = {
      type: ActionTypes.GET_WEBAUTHN_CREDENTIALS,
      idToken : idToken,
      userId: userId,
      traceId: traceId
    };
    AppDispatcher.dispatch(action);
  },
  get2faWebAuthnCredentialsForLogin: function(idToken,userId, traceId) {
    var action = {
      type: ActionTypes.GET_WEBAUTHN_CREDENTIALS_FOR_LOGIN,
      idToken : idToken,
      userId: userId,
      traceId: traceId
    };
    AppDispatcher.dispatch(action);
  },
  get1faWebAuthnCredentialsForLogin: function (loginId, userType, clientId, realmId, initSessionId, traceId) {
      var action = {
        type: ActionTypes.GET_WEBAUTHN_CREDENTIALS_FOR_LOGIN_1FA,
        loginId: loginId,
        userType: userType,
        clientId:clientId,
        realmId:realmId,
        initSessionId:initSessionId,
        traceId: traceId
      };
      AppDispatcher.dispatch(action);
  },
  deleteWebauthnCredentials: function(idToken, deviceName, credentialId, userId, traceId ) {
    var action = {
      type: ActionTypes.DELETE_WEBAUTHN_CREDENTIALS,
      idToken : idToken,
      deviceName: deviceName,
      credentialId: credentialId,
      userId:userId,
      traceId: traceId
    };
    AppDispatcher.dispatch(action);
  },
  getUserMFAMethods: function(idToken, countryCode) {
    var action = {
      type: ActionTypes.GET_USER_MFA_METHODS,
      idToken,
      countryCode
    };
    AppDispatcher.dispatch(action);
  },
  changeUserMFAMethod: function(idToken, userId, userType, credentialId, payload, countryCode) {
    const action = {
      type: ActionTypes.CHANGE_USER_MFA_METHOD,
      idToken,
      userId,
      userType,
      credentialId,
      payload,
      countryCode
    };
    AppDispatcher.dispatch(action);
  },
  deleteUserMFAMethod: function(idToken, userId, userType, credentialId, countryCode) {
    const action = {
      type: ActionTypes.DELETE_USER_MFA_METHOD,
      idToken,
      userId,
      userType,
      credentialId,
      countryCode
    };
    AppDispatcher.dispatch(action);
  },
};

module.exports = LoginActions;
